// Colour coding + formatting for official TCF CEFR levels (receptive skills).
export function levelStyle(cefr) {
  const c = (cefr || "").toUpperCase();
  if (c.startsWith("C2")) return { chip: "bg-teal-100 text-teal-800 border-teal-300", bar: "bg-teal-500", fill: "bg-teal-50", ring: "ring-teal-300" };
  if (c.startsWith("C1")) return { chip: "bg-emerald-100 text-emerald-800 border-emerald-300", bar: "bg-emerald-600", fill: "bg-emerald-50", ring: "ring-emerald-300" };
  if (c.startsWith("B2")) return { chip: "bg-lime-100 text-lime-800 border-lime-300", bar: "bg-lime-500", fill: "bg-lime-50", ring: "ring-lime-300" };
  if (c.startsWith("B1")) return { chip: "bg-amber-100 text-amber-800 border-amber-300", bar: "bg-amber-500", fill: "bg-amber-50", ring: "ring-amber-300" };
  if (c.startsWith("A2")) return { chip: "bg-orange-100 text-orange-800 border-orange-300", bar: "bg-orange-400", fill: "bg-orange-50", ring: "ring-orange-300" };
  return { chip: "bg-slate-100 text-slate-700 border-slate-300", bar: "bg-slate-400", fill: "bg-slate-50", ring: "ring-slate-300" };
}

export function fmtStudy(seconds) {
  const s = Math.max(0, Math.round(seconds || 0));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  if (h > 0) return `${h}h ${m}min`;
  if (m > 0) return `${m}min`;
  return `${s}s`;
}
